import languages from './languages';

const booleanChoices = {
  [languages.EN]: [{ id: 'yes', name: 'Yes' }, { id: 'no', name: 'No' }],
  [languages.SV]: [{ id: 'yes', name: 'Ja' }, { id: 'no', name: 'Nej' }],
  [languages.DE]: [{ id: 'yes', name: 'Ja' }, { id: 'no', name: 'Nein' }],
};

export default booleanChoices;
